import React, {Component} from 'react';
import {connect} from 'react-redux';
import { getAdvertisers } from '../actions/advertisersActions';
import Spinner from '../components/Spinner';
import AdvertiserList from '../components/AdvertiserList';
import ErrorPage from '../errors/ErrorPage';
import { trackEvent } from '../tracking'
import { isReadOnly } from '../utils/readOnly';


class Advertisers extends Component {

  state = {
    searchQuery: ''
  };

  componentDidMount() {
    document.title = 'GALILEO - Advertisers';
    const { dispatch } = this.props;
    dispatch(getAdvertisers());
  }

  onSearch = evt => {
    const searchQuery = evt.target.value;
    if (searchQuery) {
      trackEvent({
        category: 'Search',
        action: 'Filter Advertisers List',
        label: searchQuery
      }, { throttle: true })
    }
    this.setState({ searchQuery });
  };

  filterAdvertisers = () => {
    const { advertisers } = this.props;
    const { searchQuery } = this.state;

    if (searchQuery.length < 3) {
      return advertisers;
    }

    return advertisers.filter(a =>
      a.name.toLowerCase().includes(searchQuery.toLowerCase()));
  };

  render() {
    const { isFetching, advertisers, userInfo, error } = this.props;
    return (
      <div>
        {isFetching && <Spinner />}
        {!isFetching && error && !advertisers && (
          <ErrorPage error={error} entity="advertisers" />
        )}
        {!isFetching && advertisers && (
        <AdvertiserList
          advertisers={this.filterAdvertisers()}
          searchQuery={this.state.searchQuery}
          onSearch={this.onSearch}
          isReadOnly={isReadOnly(userInfo)}
        />
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { advertisersRequest, user } = state;
  return {
    advertisers: advertisersRequest.advertisers,
    isFetching: advertisersRequest.isFetching,
    error: advertisersRequest.error,
    userInfo: {
      name: user.displayName,
      email: user.email,
      role: user.roleName
    },
  }
};

export default connect(mapStateToProps)(Advertisers);
